<template>
  <div class="background">
    <p>Seleção de multicontas</p>
    <div class="search">
      <input
        type="text"
        class="form-control input"
        placeholder="Faça uma busca"
        v-model="search"
      />
      <button class="btn btn-outline-primary" title="Limpar" @click="clear">
        Limpar
      </button>
    </div>
    <div class="container-companies">
      <ul>
        <li
          v-for="(item, index) in listCompanies"
          :key="index"
          style="padding: 10px"
        >
          <div class="itens">
            <div class="full-img">
              <img
                :src="env + '/' + item.logo"
                style="max-width: 100%; max-height: 100%"
              />
            </div>
            <h4>{{ item.name }}</h4>
            <button class="btn btn-enter" @click="enterAccount(item._id)">
              Entrar na conta
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';

export default {
  data: () => ({
    items: [],
    search: '',
    env: '',
    userData: '',
  }),

  computed: {
    listCompanies() {
      return this.items.filter((item) => {
        return item.corporateName
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    },
  },

  methods: {
    ...mapActions('companies', ['getCompany']),

    clear() {
      this.search = '';
    },

    getV3() {
      const userAuth = JSON.parse(localStorage.getItem('_indecx'));
      const { token } = userAuth;
      const host = window.location.host;
      const isStaging = host.includes('indecx.pe');
      const isLocalhost = host === 'localhost:8080' || host === 'localhost';
      // eslint-disable-next-line no-nested-ternary
      const url = isLocalhost
        ? `http://localhost:8080/redirect/${token}`
        : isStaging
          ? `https://stg.app-indecx.com/redirect/${token}`
          : `https://v3.app-indecx.com/redirect/${token}`;
      window.location.href = url;
    },

    async enterAccount(companyId) {
      const response = await axios.put(
        `${process.env.API_ROOT}/sso/user-company`,
        {
          companyId,
          userId: this.userData._id,
        },
        {
          headers: {
            'x-access-token': this.userData.token,
          },
        },
      );

      const company = await this.getCompany({
        id: companyId,
        token: this.userData.token,
      });

      const { profileId, type } = response.data;

      localStorage.setItem(
        '_indecx',
        JSON.stringify({
          ...this.userData,
          profileId,
          type,
          companyId,
          token: this.userData.token,
        }),
      );

      const returnUrl = localStorage.getItem('returnUrl');

      const userPermissions = JSON.parse(localStorage.getItem('_indecx'));

      if (userPermissions.permissions.permissions.dashboard.menu) {
        if (returnUrl && returnUrl !== 'undefined') {
          this.$router.push(returnUrl);
          localStorage.removeItem('returnUrl');
        } else if (company.homePageIsNotDashboard) {
          if(company.forceV3) {
            this.getV3();
          } else {
            this.$router.push(`/powerbi`);
          }
        } else if (company.forceV3) {
          this.getV3();
        } else {
          this.$router.push(`/dashboard/${companyId}`);
        }
      }

      if (!userPermissions.permissions.permissions.dashboard.menu) {
        if(company.forceV3) {
          this.getV3();
        } else {
          this.$router.push(`/answers`);
        }
      }
    },
  },

  async created() {
    this.userData = JSON.parse(localStorage.getItem('_indecx'));
    this.env = process.env.INDECX_FILES_BUCKET;

    const resp = await axios.get(
      `${process.env.API_ROOT}/sso/data-companies/${this.$route.params.userId}`,
      {
        headers: {
          'x-access-token': this.userData.token,
        },
      },
    );

    this.items = resp.data;
  },
};
</script>

<style scoped>
.full-img {
  margin-bottom: 20px;
  height: 70px;
  max-height: 70px;
  width: 200px;
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
}

.container-companies ul {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
}

.container-companies ul li {
  list-style: none;
  flex: 0 0 33.333333%;
}

.btn-enter {
  justify-content: center;
  align-items: center;
  padding: 6px 16px;
  width: 160px;
  height: 54px;
  background: #3db374;
  border-radius: 4px;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #fff;
  border: none;
  margin-left: 10px;
}

.itens {
  padding: 10px;
  flex: 30%;
  background: #ffffff;
  border-radius: 12px;
  height: 200px;
  max-width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.background {
  background: #f0f0f0;
  height: 100vh;
  padding: 20px;
  overflow-x: auto;
}

p {
  font-weight: 700;
  font-size: 26px;
  line-height: 28px;
  margin-left: 10px;
  margin-right: 10px;
}

.search {
  height: 64px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  padding: 12px 24px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.input {
  width: 240px;
}

button:hover {
  color: #fff;
}

@media (max-width: 1310px) {
  .container-companies ul li {
    display: inline;
    list-style: none;
    flex: 0 0 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/sso/list-companies.vue